import kebabCase from 'lodash/kebabCase'

export default {
	props: {
		modifiers: String
	},
	methods: {
		nameKebabCase: function () {
			return kebabCase(this.$options.name)
		}
	},
	computed: {
		modifierClasses: function () {
			if (!this.modifiers) return ''
			return this.modifiers.split(' ')
				.map((modifier) => (`${this.nameKebabCase()}--${modifier}`))
				.join(' ')
		}
	}
}
